export function useScrollToRow() {
  return (rowId: string) => {
    setTimeout(() => {
      const row = document.querySelector(`[data-row-key="${rowId}"]`)
      row?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 300)
  }
}
